import { useMemo } from 'react';
import { useLiveClassState } from '../../../hooks/liveClassStore';
import { VideoParticipantTile } from './VideoParticipantTile';

/**
 * Orden estable: profesor, tú, quien levantó la mano y luego alfabético.
 * No se reordena por quién habla para que los recuadros no salten (y no se
 * muevan los reproductores de video en el DOM) a cada rato.
 */
const rank = (p, raisedHands) => {
    if (p.isHost) return 0;
    if (p.isManager) return 1;
    if (p.isSelf) return 2;
    if (raisedHands.includes(p.userId)) return 3;
    return 4;
};

/**
 * Columna de participantes al estilo Teams mientras el contenido (pantalla
 * compartida o pizarra) ocupa el escenario.
 */
export const VideoParticipantRail = () => {
    const participants = useLiveClassState((s) => s.participants);
    const speakingUserIds = useLiveClassState((s) => s.speakingUserIds);
    const raisedHandUserIds = useLiveClassState((s) => s.raisedHandUserIds);

    const ordered = useMemo(() => [...participants].sort((a, b) => (
        rank(a, raisedHandUserIds) - rank(b, raisedHandUserIds)
        || a.displayName.localeCompare(b.displayName, 'es')
    )), [participants, raisedHandUserIds]);

    if (!ordered.length) return null;

    return (
        <aside className="vc-rail" aria-label="Participantes en vivo">
            {ordered.map((participant) => (
                <VideoParticipantTile
                    key={participant.userId}
                    participant={participant}
                    variant="compact"
                    lazy
                    isActiveSpeaker={speakingUserIds.includes(participant.userId)}
                    handRaised={raisedHandUserIds.includes(participant.userId)}
                    className="vc-rail__tile"
                />
            ))}
        </aside>
    );
};
